export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      deliveriedNotices: [
        {
          noticeDeliveryId: 3,
          noticeDeliveryUuid: "noticedelivery003",
          deliveryAt: 1234567890123,
          deliveryType: "signage",
          deliveryTypeName: "サイネージ",
          noticeType: "opinionaire",
          noticeTypeName: "アンケート",
          deliveryToKbn: 2,
          deliveryStatus: 2,
          noticeContents: "地元の名産品について",
          noticeSenderName: "アイラ地域サポート",
        },
        {
          noticeDeliveryId: 2,
          noticeDeliveryUuid: "noticedelivery002",
          deliveryAt: 1234567890123,
          deliveryType: "normal",
          deliveryTypeName: "お知らせ",
          noticeType: "sound_broadcast",
          noticeTypeName: "音声定時放送",
          deliveryToKbn: 1,
          deliveryStatus: 4,
          noticeContents: "音声定時放送",
          noticeSenderName: "アイラ地域サポート",
        },
        {
          noticeDeliveryId: 1,
          noticeDeliveryUuid: "noticedelivery001",
          deliveryAt: 1234567890123,
          deliveryType: "normal",
          deliveryTypeName: "お知らせ",
          noticeType: "text",
          noticeTypeName: "テキストのみ",
          deliveryToKbn: 0,
          deliveryStatus: 8,
          noticeContents: "〇〇大会延期のお知らせ",
          noticeSenderName: "アイラ地域サポート",
        }
      ]
    }
  }
}